import { RootState } from "../../../store/indexReducers";

export const getNotification = (state: RootState) =>
  state?.notificationReducer?.notification;
